import { useContext } from 'react';
import { isNil } from '@wistia/type-guards';
import { AriaLiveContext } from '../../providers/AriaLiveProvider';

type AriaLiveContextType = {
  announce: (message: string, politeness?: 'assertive' | 'polite') => void;
};

export const useAriaLive = (): AriaLiveContextType => {
  const context = useContext(AriaLiveContext);

  if (isNil(context)) {
    throw new Error('useAriaLive must be used within an AriaLiveProvider');
  }

  return context;
};
